import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

import { useReservationHideMailMagazineQuestion } from "./hooks/use-hide-mail-magazine-question";

export const QuestionReservationHideMailMagazineQuestion = () => {
	const { isEdited, hasError, hideMailMagazineQuestion, onSetHideMailMagazineQuestion } =
		useReservationHideMailMagazineQuestion();

	const title = "メルマガ配信許可に関する設定";
	const guide =
		"お客様の予約のステップの最後に聞かれる、<br /><strong>「予約したホテルからイベントやお得な情報等のお知らせをEメールで受信しますか？」</strong>の質問を非表示にすることができます。<br />デフォルトでは表示されます。";

	const label = "メルマガ配信の許可を取る質問項目を非表示にする";

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={title}
			isEdited={isEdited}
			hasError={hasError}
			guide={guide}
			inputChildren={
				<CheckboxField
					value={hideMailMagazineQuestion.value}
					errorMessage={hideMailMagazineQuestion.error}
					label={label}
					handleChange={onSetHideMailMagazineQuestion}
				/>
			}
		/>
	);
};

QuestionReservationHideMailMagazineQuestion.displayName = "QuestionReservationHideMailMagazineQuestion";
